// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker__control {
  position: relative;
  width: 314px;
}
.dl-datepicker__control-veil {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 6;
}
.dl-datepicker__popup-content {
  width: 314px;
  height: 50vh;
  max-height: 600px;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}
.dl-datepicker__sheet {
  position: relative;
  height: calc(90vh - 40px);
  max-height: 600px;
  padding: 0;
  overflow: hidden;
}
.dl-datepicker__input_error {
  color: var(--g-color-text-hint);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Datepicker.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,YAAA;AAAR;AAGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AADR;AAII;EACI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAFR;AAKI;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAHR;AAOQ;EACI,+BAAA;AALZ","sourcesContent":[".dl-datepicker__control {\n  position: relative;\n  width: 314px;\n}\n.dl-datepicker__control-veil {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  z-index: 6;\n}\n.dl-datepicker__popup-content {\n  width: 314px;\n  height: 50vh;\n  max-height: 600px;\n  overflow: hidden;\n  user-select: none;\n}\n.dl-datepicker__sheet {\n  position: relative;\n  height: calc(90vh - 40px);\n  max-height: 600px;\n  padding: 0;\n  overflow: hidden;\n}\n.dl-datepicker__input_error {\n  color: var(--g-color-text-hint);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
